<template>
    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl>
            <v-form id="add-user" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap align-center justify-center fill-height>
                    <!-- osebni podatki -->
                    <v-flex xs12 sm12 md10 lg10>
                        <v-card>
                            <v-toolbar card color="white">
                                <v-icon   medium>account_box</v-icon>
                                <v-toolbar-title class="body-2">
                                <h3 class="font-weight-regular">Osebni podatki</h3>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="toggleCardText('osebni-podatki')">
                                    <v-icon>{{ card1 ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-divider v-show="card1"></v-divider>
                            <v-card-text v-show="card1">
                                <!-- imetnik -->
                                <v-text-field
                                    v-model="name"
                                    label="Imetnik (ime in priimek)"
                                    :rules="userDataRules"
                                    required
                                ></v-text-field>

                                <!-- ulica -->
                                <v-text-field
                                    v-model="address"
                                    label="Ulica (stalno prebivališče)"
                                ></v-text-field>

                                <!-- kraj -->
                                <v-text-field
                                    v-model="city"
                                    label="Kraj (stalno prebivališče)"
                                ></v-text-field>
                                <!-- telefonska številka -->
                                <v-text-field
                                    v-model="phoneNumber"
                                    label="Telefonska številka"
                                    type="number"
                                ></v-text-field>
                                <!-- email -->
                                <v-text-field
                                    v-model="email"
                                    label="Elektronski naslov"
                                ></v-text-field>
                                <!-- emšo -->
                                <v-text-field
                                    v-model="emso"
                                    label="EMŠO"
                                    type="number"
                                ></v-text-field>
                                <!-- davčna številka -->
                                <v-text-field
                                    v-model="taxNumber"
                                    label="Davčna številka"
                                    type="number"
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <!-- podatki o vozilu -->
                    <v-flex xs12 sm12 md10 lg10>
                        <v-card>
                            <v-toolbar card color="white">
                                <v-icon   medium>time_to_leave</v-icon>
                                <v-toolbar-title class="body-2">
                                <h3 class="font-weight-regular">Podatki o vozilu</h3>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="toggleCardText('podatki-o-vozilu')">
                                    <v-icon>{{ card2 ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-divider v-show="card2"></v-divider>
                            <v-card-text v-show="card2">
                                <!-- registrske številke -->
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex x12 align-content-center>
                                            <p>Registrske številke (do 5 reg. številk):</p>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrationNumber1"
                                                label="Registrska številka 1"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrationNumber2"
                                                label="Registrska številka 2"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrationNumber3"
                                                label="Registrska številka 3"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrationNumber4"
                                                label="Registrska številka 4"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrationNumber5"
                                                label="Registrska številka 5"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-start v-bind="columnBinding">
                                        <v-flex xs12 align-content-end>
                                            <v-switch
                                                v-model="licensePlateRecognition"
                                                label="Dovoli vstop s prepoznavo tablic"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <!-- urejanje omejitev -->
                    <v-flex xs12 sm12 md10 lg10>
                        <v-card>
                            <v-toolbar card color="white">
                                <v-icon   medium>assignment</v-icon>
                                <v-toolbar-title class="body-2">
                                <h3 class="font-weight-regular">Urejanje omejitev</h3>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="toggleCardText('urejanje-omejitev')">
                                    <v-icon>{{ card3 ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-divider v-show="card3"></v-divider>
                            <v-card-text v-show="card3">
                                <!-- datumska omejitev -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >   
                                    <v-icon medium>date_range</v-icon>
                                    <v-toolbar-title class="body-2">Datumska omejitev</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs8 align-content-center>
                                            <v-subheader><strong>Veljavnost dovolilnice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="startDateMenu"
                                                :close-on-content-click="false"
                                                v-model="startDateMenu"
                                                :nudge-right="40"
                                                :return-value.sync="restrictionStartDate"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="restrictionStartDateFormatted"
                                                    label="Datum od"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                ></v-text-field>
                                                <v-date-picker @input="startDateMenuSave(restrictionStartDate)" v-model="restrictionStartDate" no-title scrollable locale="sl-si">
                                                    <v-spacer></v-spacer>
                                                    <!--<v-btn flat color="primary" @click="startDateMenu = false">Prekliči</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.startDateMenu.save(restrictionStartDate)">Potrdi</v-btn>-->
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="endDateMenu"
                                                :close-on-content-click="false"
                                                v-model="endDateMenu"
                                                :nudge-right="40"
                                                :return-value.sync="restrictionEndDate"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="restrictionEndDateFormatted"
                                                    label="Datum do"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                ></v-text-field>
                                                <v-date-picker @input="endDateMenuSave(restrictionEndDate)" v-model="restrictionEndDate" no-title scrollable locale="sl-si">
                                                    <v-spacer></v-spacer>
                                                    <!--<v-btn flat color="primary" @click="endDateMenu = false">Prekliči</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.endDateMenu.save(restrictionEndDate)">Potrdi</v-btn>-->
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>    
                                <br>
                                <!-- RFID -kartica -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >   
                                    <v-icon medium>credit_card</v-icon>
                                    <v-toolbar-title class="body-2">RFID kartica</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>ID kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="cardId"
                                                label="ID kartice"
                                                required
                                                :disabled="!cardIdInputEnabled"
                                                ref="cardId"
                                                :rules="getCardNumber ? cardIdRules : []"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Serijska številka kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="cardNumber"
                                                label="Serijska št. kartice"
                                                required
                                                :disabled="!cardNumberInputEnabled"
                                                ref="cardNumber"
                                                @keyup.enter.native="RfidNr"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Kartica blokirana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-switch
                                                v-model="cardBlocked"
                                                label="Blokiraj kartico"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-left>
                                            <v-subheader><strong></strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-left>
                                            <v-btn :block="$vuetify.breakpoint.xsOnly" :disabled="storeUserLoading || deleteUserLoading" :loading="scanRfidLoading" color="success" @click="enableRfidCardInput"><v-icon left>wifi</v-icon>Klikni tukaj za skeniranje</v-btn>
                                            <v-btn :block="$vuetify.breakpoint.xsOnly" :disabled="scanRfidLoading ||storeUserLoading" color="error" @click="removeRfidCard"><v-icon left>clear</v-icon>Odstrani kartico</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container> 

                                <br>
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >   
                                    <v-icon medium>not_interested</v-icon>
                                    <v-toolbar-title class="body-2">Omejitve</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Izberi tip omejitve</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-select
                                                :items="restrictionTypes"
                                                label="Tip omejitve"
                                                item-text="name"
                                                item-value="id"
                                                v-model="restrictionId"
                                                persistent-hint
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <br>
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >   
                                    <v-icon medium>motorcycle</v-icon>
                                    <v-toolbar-title class="body-2">Prehod s kolesom</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 sm12 md4 lg4 align-content-center>
                                            <v-subheader><strong>Dovoli uporabo kolesa</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-switch
                                                v-model="bikeEnabled"
                                                :label="bikeEnabledLabel"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <br>
                                <!-- Časovne omejitve -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >   
                                    <v-icon medium>access_time</v-icon>
                                    <v-toolbar-title class="body-2">Časovna omejitev</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Časovna omejitev</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-switch
                                                v-model="useTimeRestriction"
                                                label="Upoštevaj časovno omejitev"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Začetek časovne omejitve (izberi uro)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="startTimeMenu"
                                                :close-on-content-click="false"
                                                v-model="startTimeMenu"
                                                :nudge-right="40"
                                                :return-value.sync="restrictionStartTime"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="restrictionStartTime"
                                                    label="Začetek"
                                                    prepend-icon="access_time"
                                                    readonly
                                                ></v-text-field>
                                                <v-time-picker
                                                    v-if="startTimeMenu"
                                                    format="24hr"
                                                    v-model="restrictionStartTime"
                                                    @change="$refs.startTimeMenu.save(restrictionStartTime)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                     <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Konec časovne omejitve (izberi uro)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="endTimeMenu"
                                                :close-on-content-click="false"
                                                v-model="endTimeMenu"
                                                :nudge-right="40"
                                                :return-value.sync="restrictionEndTime"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="restrictionEndTime"
                                                    label="Konec"
                                                    prepend-icon="access_time"
                                                    readonly
                                                ></v-text-field>
                                                <v-time-picker
                                                    v-if="endTimeMenu"
                                                    format="24hr"
                                                    v-model="restrictionEndTime"
                                                    @change="$refs.endTimeMenu.save(restrictionEndTime)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Časovna omejitev zadrževanja (minute)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="restrictionTimePeriod"
                                                label="Čas v minutah"
                                                required
                                                prepend-icon="hourglass_empty"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container> 
                            </v-card-text>
                        </v-card>
                        <br>
                        <v-btn
                        :block="$vuetify.breakpoint.xsOnly"
                        color="success"
                        @click="submit"
                        :loading="storeUserLoading"
                        :disabled="scanRfidLoading || deleteUserLoading"
                    >
                    <v-icon left>arrow_forward</v-icon>
                    Posodobi uporabnika
                    </v-btn>

                    <v-btn 
                        :block="$vuetify.breakpoint.xsOnly"
                        :disabled="scanRfidLoading || storeUserLoading || deleteUserLoading"
                        color="info" 
                        @click="getUser">
                        <v-icon left>refresh</v-icon>
                        Prekliči spremembe
                    </v-btn>

                    <v-btn 
                        :block="$vuetify.breakpoint.xsOnly"
                        :disabled="scanRfidLoading || storeUserLoading || deleteUserLoading"
                        color="error" 
                        @click="deleteUser">
                        <v-icon left>cancel</v-icon>
                        Izbriši uporabnika
                    </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-dialog v-model="dialog" persistent max-width="490">
                <v-card>
                    <!--<v-card-title class="headline">Ste prepričani da želite izbrisati uporabnika?</v-card-title>-->
                    <v-card-text>
                    <v-icon flat>delete_forever</v-icon>
                    {{ dialog_text }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="dialogCancel()">Prekliči</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="dialogConfirm()">Nadaljuj</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'rfid-edit-user',
    data: () => ({
        card1: true,
        card2: true,
        card3: true,
        valid: false,
        rfidUserData: null,
        rfidUserId: null,
        rfidUserUuid: null,

        //osebni podatki
        name: null,
        address: null,
        city: null, 
        phoneNumber: null,
        email: null,
        emso: null,
        taxNumber: null,

        //podatki o vozilu
        registrationNumber1: null,
        registrationNumber2: null,
        registrationNumber3: null,
        registrationNumber4: null,
        registrationNumber5: null,
        licensePlateRecognition: null,
        //urejanje omejitev
        restrictionStartDate: null,
        restrictionEndDate: null,
        cardId: null,
        cardNumber: null,
        cardScanInput: null,
        cardBlocked: false,
        restrictionId: null,
        bikeEnabled: null,

        //časovna omejitev
        useTimeRestriction: null,
        restrictionStartTime: null,
        restrictionEndTime: null,
        restrictionTimePeriod: null,

        restrictionStartDateFormatted: null,
        restrictionEndDateFormatted: null,

        startDateMenu: false,
        endDateMenu: false,

        startTimeMenu: false,
        endTimeMenu:false,

        userDataRules: [
            v => !!v || 'Polje imetnik je obvezno.',
        ],

        registrationNumber1Rules: [
            v => !!v || 'Vnos vsaj ene od registrskih številk je obvezen!',
        ],

        cardIdRules: [
            v => (!!v) || 'Vnos ID kartice je obvezen!',
        ],

        scanRfidLoading: false,
        storeUserLoading: false,
        deleteUserLoading: false,

        cardIdInputEnabled: false,
        cardNumberInputEnabled: false,

        restrictionTypes: [],

        //dialog
        dialog: false,
        dialog_title: '',
        dialog_text: '',
        dialog_confirm: false,
    }),

    watch: {
        restrictionStartDate (val) {
            this.restrictionStartDateFormatted = this.formatDate(val)
        },

        restrictionEndDate (val) {
            this.restrictionEndDateFormatted = this.formatDate(val)
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        getCardNumber() {
           if(this.cardNumber == null || this.cardNumber == '') return false

           return true
        },

        bikeEnabledLabel() {
            if(this.bikeEnabled) {
                return 'Da'
            }

            return 'Ne'
        }
    },

    methods: {
        startDateMenuSave(value) {
            this.$refs.startDateMenu.save(value)
            this.startDateMenu = false
        },

        endDateMenuSave(value) {
            this.$refs.endDateMenu.save(value)
            this.endDateMenu = false
        },

        submit() {
            var vm = this
            if(this.$refs.form.validate()) {
                this.storeUserLoading = true
                vm.$store.commit('SET_PROGRESS', true)
                this.$store.dispatch('UPDATE_RFID_USER', {
                    id: this.rfidUserId,
                    name: this.name,
                    address: this.address,
                    city: this.city,
                    phoneNumber: this.phoneNumber,
                    email: this.email,
                    emso: this.emso,
                    taxNumber: this.taxNumber,
                    registrationNumber1: this.registrationNumber1,
                    registrationNumber2: this.registrationNumber2,
                    registrationNumber3: this.registrationNumber3,
                    registrationNumber4: this.registrationNumber4,
                    registrationNumber5: this.registrationNumber5,
                    licensePlateRecognition: this.licensePlateRecognition,
                    restrictionStartDate: (this.restrictionStartDateFormatted != null) ?  this.restrictionStartDate : null,
                    restrictionEndDate: (this.restrictionEndDateFormatted != null) ?  this.restrictionEndDate : null,
                    cardId: this.cardId,
                    cardNumber: this.cardNumber,
                    cardScanInput: this.cardScanInput,
                    cardBlocked: this.cardBlocked,
                    restrictionId:  this.restrictionId,
                    bikeEnabled: this.bikeEnabled,
                    useTimeRestriction: this.useTimeRestriction,
                    restrictionStartTime: this.restrictionStartTime,
                    restrictionEndTime: this.restrictionEndTime,
                    restrictionTimePeriod: this.restrictionTimePeriod

                })
                .then(response => {
                    this.storeUserLoading = false
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarText', "Posodobitev podatkov za uporabnika " + this.name + " je uspela.")
                    vm.$store.commit('snackbarMode', '')
                    vm.$store.commit('snackbarTimeout', 7000)
                    vm.$store.commit('snackbarDisplay', true)
                    
                })
                .catch(error => {
                    console.log('UPDATE RFID USER error')
                    this.storeUserLoading = false
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarMode', 'multi-line')
                    vm.$store.commit('snackbarText', 'Pri posodobitvi podatkov uporabnika ' + this.name + ' je prišlo do napake. Prosimo poskusite ponovno.')
                    vm.$store.commit('snackbarDisplay', true)

                })
                

            } else {
                this.$vuetify.goTo('#add-user', {
                    duration: 500,
                    offset: 0,
                    easing: 'easeInOutCubic'
                })
            }
        },

        clear() {

        },

        deleteUser() {
            this.dialog_text = 'Ste prepričani da želite odstraniti uporabnika ' + this.name + '?'
            this.dialog = true
        },

        dialogConfirm() {
            this.dialog_confirm = true
            this.dialog = false
            this.deleteUserLoading = true
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            //izbriši uporabnika
            vm.$store.dispatch('DELETE_RFID_USER', vm.rfidUserId)
            .then(response => {
                this.deleteUserLoading = false
                vm.$store.commit('SET_PROGRESS', false)

                vm.$store.commit('snackbarDisplay', false)
                vm.$store.commit('snackbarText', 'Uporabnik ' + vm.name + ' je bil odstranjen iz sistema.')
                vm.$store.commit('snackbarMode', '')
                vm.$store.commit('snackbarTimeout', 7000)
                vm.$store.commit('snackbarDisplay', true)

                setTimeout(() => {
                    vm.$store.commit('snackbarDisplay', false)
                    this.$router.push({
                        name: 'users-list'
                    })
                }, 3000)
            })
            .catch(error => {
                console.log("Pri brisanju uporabnika je prišlo do napake!")
                console.log(error)
                this.deleteUserLoading = false
                vm.$store.commit('SET_PROGRESS', false)
                vm.$store.commit('snackbarDisplay', false)
                vm.$store.commit('snackbarText', 'Pri brisanju uporabnika ' + vm.name + ' je prišlo do napake. Prosimo poskusite ponovno.')
                vm.$store.commit('snackbarMode', 'multi-line')
                vm.$store.commit('snackbarTimeout', 7000)
                vm.$store.commit('snackbarDisplay', true)
            })
        },

        dialogCancel() {
            this.dialog_confirm = false
            this.dialog = false
        },

        toggleCardText(card) {
            if(card == 'osebni-podatki') {
                this.card1 = !this.card1
            }

            if(card == 'podatki-o-vozilu') {
                this.card2 = !this.card2
            }

            if(card == 'urejanje-omejitev') {
                this.card3 = !this.card3
            }
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        RfidNr() {
            let data = this.cardNumber
            this.cardScanInput = this.cardNumber
            var vm = this
            this.scanRfidLoading = true
            this.$store.dispatch('CONVERT_RFID_NR', {nr: data})
            .then(response => {
                //console.log(response)
                this.cardNumber = response.data.rfidNr
                this.scanRfidLoading = false
                vm.$store.commit('snackbarDisplay', false)
                vm.$store.commit('snackbarText', "Kartica uspešno poskenirana. Serijska številka kartice: " +  response.data.rfidNr + ". Vpišite še ID kartice.")
                vm.$store.commit('snackbarMode', 'multi-line')
                vm.$store.commit('snackbarTimeout', 9000)
                vm.$store.commit('snackbarDisplay', true)

                this.cardIdInputEnabled = true
                setTimeout(() => {
                        vm.$refs.cardId.focus()
                    }, 350)

            })
            .catch(error => {
                console.log('RfidNr error')
                console.log(error)
                this.scanRfidLoading = false    
                this.removeRfidCard()
                vm.$store.commit('snackbarDisplay', false)
                vm.$store.commit('snackbarText', 'Pri skeniranju kartice je prišlo do napake. Poskusite ponovno.')
                vm.$store.commit('snackbarMode', '')
                vm.$store.commit('snackbarTimeout', 7000)
                vm.$store.commit('snackbarDisplay', true)

            })

            this.cardNumberInputEnabled = false
        },

        scanRfidCard() {

        },

        removeRfidCard() {
            this.cardId = null;
            this.cardNumber = null;
            this.cardScanInput = null;
            this.cardBlocked = null;

            this.cardIdInputEnabled = false;
            this.cardNumberInputEnabled = false;
            this.$refs.form.validate();
            this.$refs.cardId.blur();
            this.$refs.cardNumber.blur();

        },

        enableRfidCardInput() {
            this.removeRfidCard()
            this.cardNumberInputEnabled = true

            setTimeout(() => {
                this.$refs.cardNumber.focus()
            }, 350)
        },

        getUser() {
            //podatki uporabnika
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            this.$store.dispatch('GET_RFID_USER', this.$route.params.id)
            .then(response => {
                //consoleconsole.log(response)
                this.rfidUserData = response.data
                this.rfidUserId = response.data.id
                this.rfidUserUuid = response.data.uuid
                vm.name = response.data.name
                vm.address = response.data.address
                vm.city = response.data.city
                vm.phoneNumber = response.data.phone_number
                vm.email = response.data.email
                vm.emso = response.data.emso
                vm.taxNumber = response.data.tax_number
                vm.registrationNumber1 = response.data.registration_number_1
                vm.registrationNumber2 = response.data.registration_number_2
                vm.registrationNumber3 = response.data.registration_number_3
                vm.registrationNumber4 = response.data.registration_number_4
                vm.registrationNumber5 = response.data.registration_number_5
                vm.restrictionStartDate = response.data.restriction_start_date
                vm.restrictionStartDateFormatted = vm.formatDate(response.data.restriction_start_date)
                vm.restrictionEndDate = response.data.restriction_end_date
                vm.restrictionEndDateFormatted = vm.formatDate(response.data.restriction_end_date)
                if(response.data.license_plate_recognition == 1 || response.data.license_plate_recognition == "1") {
                    this.licensePlateRecognition = "1"
                } else {
                    this.licensePlateRecognition = null
                }

                if(response.data.use_time_restriction == 1 || response.data.use_time_restriction == "1") {
                    this.useTimeRestriction = "1"
                } else {
                    this.useTimeRestriction = null
                }

                vm.cardId = response.data.card_id
                vm.cardNumber = response.data.card_number
                vm.cardScanInput = response.data.card_scan_input
                if(response.data.card_blocked == 1 || response.data.card_blocked == "1") {
                    vm.cardBlocked = response.data.card_blocked + ""
                } else {
                    vm.cardBlocked = null
                }

                vm.restrictionId = response.data.restriction_id
                
                if(response.data.bike_enabled == 1 || response.data.bike_enabled == "1") {
                    vm.bikeEnabled = "1"
                } else {
                    vm.bikeEnabled = null
                }

                vm.restrictionStartTime = response.data.restriction_start_time
                vm.restrictionEndTime = response.data.restriction_end_time
                vm.restrictionTimePeriod = response.data.restriction_time_period

                vm.$store.commit('SET_PROGRESS', false)
            })
            .catch(error => {
                console.log("Napaka pri pridobivanju podatkov uporabnika!")
                console.log(error)
                console.log(error.response.status)
                vm.$store.commit('SET_PROGRESS', false)
            })
        }
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name)

        //tipi omejitev
        this.$store.dispatch('RESTRICTION_TYPES')
        .then(response => {
            this.restrictionTypes = response.data
        })
        .catch(error => {
            console.log("RESTRICTION_TYPES error")
            console.log(error)
        })

        this.getUser()

        
    },

    mounted() {

    },

    destroyed() {
        this.$store.commit('SET_PROGRESS', false)
        this.$store.commit('snackbarDisplay', false)
    }
}
</script>

<style>

</style>